import { combineReducers } from 'redux';
import autoplay from './autoplay';
import data from './dataReducer';
import countries from './countriesReducer';
import options from './optionsReducer';
import selection from './selectionReducer';
import userLocation from './userLocationReducer';
import prices from './pricesReducer';
import currencies from './currenciesReducer';
import {routerReducer} from 'react-router-redux';

const rootReducer = combineReducers({
  autoplay,
  data,
  options,
  selection,
  userLocation,
  countries,
  prices,
  currencies,
  routing: routerReducer
});

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/